import React, { useState, useEffect } from 'react';
import './EmojiList.css';

const EmojiList = ({ onSelect }) => { // Adicione a prop onSelect
  const [emojis, setEmojis] = useState([]);

  useEffect(() => {
    fetch('https://emoji-api.com/emojis?access_key=cc7bacf7595ec1a04d9fb64d06a817e767646af2')
      .then(response => response.json())
      .then(data => setEmojis(data))
      .catch(error => console.error('Erro ao carregar emojis:', error));
  }, []);

  const handleCopy = (emoji) => {
    navigator.clipboard.writeText(emoji)
      .then(() => {
        // Chama a função de callback onSelect para passar o emoji selecionado
        if (onSelect) onSelect(emoji);
      })
      .catch(err => console.error('Erro ao copiar emoji:', err));
  };

  return (
    <div className="emoji-list-container">
      <div className="emoji-grid">
        {emojis.map(emoji => (
          <div 
            key={emoji.unicode}
            className="emoji-item"
            onClick={() => handleCopy(emoji.character)}
          >
            {emoji.character}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmojiList;
